module.exports = __webpack_public_path__ + "img/bg-default.f5eef330.png";